import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { toast } from 'react-toastify';

export const useAdminMode = () => {
  const [showAdminDialog, setShowAdminDialog] = useState(false);
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [originalUsername, setOriginalUsername] = useState(null);
  const { getToken, user } = useAuth();

  // چک کردن وضعیت impersonation در هنگام لود
  useEffect(() => {
    const originalToken = localStorage.getItem('original_token');
    const originalUser = localStorage.getItem('original_username');
    if (originalToken && originalUser) {
      setIsImpersonating(true);
      setOriginalUsername(originalUser);
    }
  }, []);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.ctrlKey && event.shiftKey && event.key === 'A') {
        setShowAdminDialog(true);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  const loginAsUser = async (username) => {
    try {
      const token = getToken();
      console.log('Attempting admin login for:', username);
      
      // ذخیره اطلاعات کاربر اصلی
      localStorage.setItem('original_token', token);
      localStorage.setItem('original_username', user?.username);
      setOriginalUsername(user?.username);
      
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/admin-login`,
        { username },
        { 
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          } 
        }
      );
      
      if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
        
        setIsImpersonating(true);
        toast.success(`شما با موفقیت به عنوان ${username} وارد شدید`);
        setShowAdminDialog(false);
        
        window.location.reload();
      }
    } catch (error) {
      console.error('Admin login error:', error.response || error);
      
      if (error.response?.status === 403) {
        toast.error('شما دسترسی ادمین ندارید');
      } else if (error.response?.status === 404) {
        toast.error('کاربر مورد نظر یافت نشد');
      } else if (error.response?.status === 422) {
        toast.error('داده‌های ارسالی نامعتبر است');
      } else {
        toast.error('خطا در ورود به عنوان کاربر دیگر');
      }
    }
  };

  const exitImpersonation = () => {
    const originalToken = localStorage.getItem('original_token');
    if (originalToken) {
      localStorage.setItem('token', originalToken);
      axios.defaults.headers.common['Authorization'] = `Bearer ${originalToken}`;
      
      // پاک کردن اطلاعات impersonation
      localStorage.removeItem('original_token');
      localStorage.removeItem('original_username');
      setIsImpersonating(false);
      setOriginalUsername(null);
      
      toast.success('با موفقیت به اکانت اصلی بازگشتید');
      window.location.reload();
    }
  };

  return {
    showAdminDialog,
    setShowAdminDialog,
    isImpersonating,
    originalUsername,
    loginAsUser,
    exitImpersonation
  };
}; 